import React, { PropsWithChildren } from 'react';
import { Link, useColorModeValue, LinkProps, forwardRef } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { Colors } from 'src/shared';

export interface LinkButtonProps extends PropsWithChildren<LinkProps> {
  to: string;
}

const LinkButton = forwardRef((props: LinkButtonProps, ref) => {
  const { to, children, ...remainingProps } = props;
  const color = useColorModeValue(Colors.light.whiteText, Colors.dark.whiteText);
  const linkHoverColor = useColorModeValue('gray.800', 'white');
  return (
    <Link
      ref={ref}
      as={RouterLink}
      color={color}
      px={4}
      py={1}
      textAlign="center"
      to={to}
      _hover={{
        textDecoration: 'none',
        color: linkHoverColor,
      }}
      _focus={{
        boxShadow: 'none',
      }}
      {...remainingProps}
    >
      {children}
    </Link>
  );
});

export default LinkButton;
